import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { pageContext } from 'ctm-util-functions';

/**
 * A comparable results row that has toggleable call options
 */
class _ComparableResultsRow extends Component {

    constructor(props) {
        super(props);

        this.state = {
            callToggle: false,
            callBackToggle: false
        };
    }

    /**
     * Don't re-render unless callBackSuccess has changed
     * @param {Object} nextProps - The incoming set of props
     * @param {Object} nextState - The incoming component state
     * @returns {Boolean} - True if the component should re-render
     */
    shouldComponentUpdate = (nextProps, nextState) => {
        const { callBackSuccess, breakpoint, product } = this.props;
        const { callToggle, callBackToggle } = this.state;
        return nextProps.callBackSuccess !== callBackSuccess
            || nextState.callToggle !== callToggle
            || nextState.callBackToggle !== callBackToggle
            || nextProps.breakpoint !== breakpoint
            || nextProps.product.getIn(['productMeta', 'id']) !== product.getIn(['productMeta', 'id']);
    };

    // @todo future refactor when more use cases for maintaining state at this row level are required
    /**
     * All events that the results listens for must be defined here.
     * All child components rendered receive the event handler and can change state of the results
     * Callback functions must pass an object with at least an id key. e.g. { id: 'call, extraArgs: ... }
     * @param {Object} type - the callback arguments
     * @param {Object} proxy - the react proxy event object
     * @param {Object} event - standard javascript event object
     */
    eventHandler = (type) => {
        switch (type.id) {
            // eslint-disable-next-line no-case-declarations
            case 'call':
                this.setState((state) => ({ callToggle: !state.callToggle, callBackToggle: false }));
                break;
            case 'callBack':
                this.setState((state) => ({ callToggle: false, callBackToggle: !state.callBackToggle }));
                break;
            // case 'pinnedProduct':
            //     // eg set state the allows boreder to be applied to the row
            //     break;
            default:
                // eslint-disable-next-line no-console
                console.error(`No event handler defined for event type ${type.id}`);
        }
    };

    /**
     * Lifecycle method to update state for new props
     * @param {Object} nextProps - The incoming set of props
     */
    componentWillReceiveProps = (nextProps) => {
        const { callBackToggle } = this.state;
        if (nextProps.callBackSuccess && callBackToggle) {
            const visibility = !nextProps.callBackSuccess;
            this.setState({
                callBackToggle: visibility
            });
        }
    };

    /**
     * Prepare the state props and build the layout through the builder director
     * @returns {Node} the comparable results row component
     */
    render = () => {
        const { product, layout, id, breakpoint, index, filter, filterSchema } = this.props;
        const stateProps = {
            product,
            filter,
            filterSchema,
            eventHandler: this.eventHandler,
            ...this.state
        };
        const productId = id && product.getIn(['productMeta', 'id']);
        return (
            <div id={id} data-productid={productId}>
                {pageContext.getProps().director.constructComponents(layout, { stateProps, breakpoint, index })}
            </div>
        );
    };

}

_ComparableResultsRow.propTypes = {
    product: PropTypes.instanceOf(Map).isRequired,
    breakpoint: PropTypes.string.isRequired,
    layout: PropTypes.array.isRequired,
    callBackSuccess: PropTypes.bool,
    id: PropTypes.string,
    index: PropTypes.number,
    filter: PropTypes.string,
    filterSchema: PropTypes.object
};

const mapStateToProps = (state) => {
    const callBackSuccess = state.getIn(['page', 'callBackSuccess']);

    return {
        callBackSuccess
    };
};

const ComparableResultsRow = connect(mapStateToProps)(_ComparableResultsRow);
export { _ComparableResultsRow, ComparableResultsRow };
